<template>
  <ChapterGroup v-if="subChapters.length" :items="subChapters" :opened="true" />

  <ChapterGridPdfCategories
    v-else-if="
      category.childrenType === 'annals' ||
      category.childrenType === 'essential'
    "
    :category="category"
    :library-book-id="libraryBookId"
  />
  <ChapterGridPdfPosts
    v-else-if="isPostsPdfGrid"
    :category="category"
    :library-book-id="libraryBookId"
  />
  <ChapterGridVideoItems
    v-else-if="isVideoGrid"
    :category="category"
    :library-book-id="libraryBookId"
  />

  <ChapterBlock v-else :category="category" :library-book-id="libraryBookId" />

  <ChapterCompleted :category="category" />

  <Teleport defer to="#banner-bottom">
    <RecommendationBanner
      v-if="profile.featureFlags.adaptive && progressionsDoneCount > 0"
    />
  </Teleport>
</template>
<script lang="ts" setup>
const { categoryManager, libraryBookId, mPageMedias } =
  inject(INJECT_CATEGORY_PAGE);

const profile = useProfileStore();

const { category: categoryRoot } = categoryManager;

const category = ref<CategorySchema>(categoryRoot.value);

const isPostsPdfGrid = computed(() => {
  if (
    category.value.posts.length &&
    !category.value.exercises.length &&
    !category.value.children.length
  ) {
    // add check for list of contentPDF
    return !category.value.posts.some(
      (item) => item.contentType !== PostTypes.ContentPDF
    );
  }
  return false;
});

if (categoryRoot.value.contentType === ContentTypes.Chapter) {
  category.value = categoryRoot.value.children[0];
}

const { progressionsDoneCount } = inject(INJECT_PROGRESSION_EXERCISES);

const subChapters = computed(() => {
  const children = category.value.children || [];
  const subChapters = children.filter(
    (child) => child.contentType === ContentTypes.SubChapter
  );
  return subChapters;
});

const isVideoGrid = computed(() => {
  if (category.value.childrenType !== 'course_video') return false;
  if (!category.value.posts.length) return false;
  const medias = category.value.posts.reduce((acc, post) => {
    if (post.medias && post.medias.length) {
      const mediaId = post.medias[0].id;
      if (mPageMedias.value.has(mediaId)) {
        const media = mPageMedias.value.get(mediaId);
        if (media.mime === 'video/mp4') {
          acc.push(media);
        }
      }
    }
    return acc;
  }, []);
  if (medias.length < category.value.posts.length) return false;
  return true;
});
</script>
<style lang="scss" scoped>
.sections {
  display: flex;
  flex-direction: column;
  gap: var(--gap_xl);
}
</style>
